import { gql } from '@apollo/client'

const SEARCH_POLICY_CLASSES = gql`
  query SEARCH_POLICY_CLASSES($searchTerm: String!, $insurancePolicy: ID, $insuranceCompany: ID) {
    searchPolicyClasses(searchTerm: $searchTerm, insurancePolicy: $insurancePolicy, insuranceCompany: $insuranceCompany) {
      id
      name
      maxLimit
      insuranceLimit
      insurancePercentage
      insuranceUnlimited
      approvalRequired
      insurancePolicy {
        id
        policyNumber
        holderName
      }
    }
  }
`

export default SEARCH_POLICY_CLASSES
